import { Component, OnInit } from '@angular/core';
import { Location, LocationService } from "services/location.service";
import { MetaService } from 'services/meta.service';

@Component({
	selector: 'ras-furniture-storage-page',
	templateUrl: './furniture-storage-page.component.html',
	styleUrls: ['./furniture-storage-page.component.sass']
})
export class FurnitureStoragePageComponent implements OnInit {

	locations: Location[] = []
	videos = [
		{
			code: '-086NoMci6U',
			preview: '/assets/video-Jabu.jpg',
			position: '20%'
		},
		{
			code: 'zIrpM6-VfJY',
			preview: '/assets/video-Santiago.jpg',
			position: '10%'
		},
	]
	video = null;

	constructor(private locationService: LocationService, private meta: MetaService) { }

	ngOnInit() {
		this.meta.apply('furniture-storage')

		if (this.videos.length > 0) {
			let video_i = Math.floor(Math.random()*this.videos.length);
			this.video = this.videos[video_i];
		}

		this.locationService.get_all()
		.then(locations => {
			this.locations = locations
		})
	}

}
